import React, {Component} from 'react';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import ItemsList from './ItemsList';
import ItemService from "./services/item.service";
import * as FaIcons from "react-icons/fa";
import { Button, Container, FormControl, FormLabel } from 'react-bootstrap';
import { PageHeader, NewHeader } from './AuxiliaryFunctions';
import TopAndSideBar from './TopAndSideBar';

var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

//const ExcelJS = require('exceljs');

class Items extends Component {

  constructor(props) {
    super(props);
    this.onChangeItemFilterByDescr = this.onChangeItemFilterByDescr.bind(this);
    this.onChangeSortField = this.onChangeSortField.bind(this);
    this.onChangeSortType = this.onChangeSortType.bind(this);
    this.performSearch = this.performSearch.bind(this);

    this.state = {
      listOfItems: null,
      ItemFilterByDescr: '',
      SortField: 'id',
      SortType: 'ASC'
    };
  }  

  onChangeSortType() {
    this.setState({
      SortType: (this.state.SortType == 'DESC')?'ASC':'DESC'
    });
    this.performSearch(this.state.ItemFilterByDescr,this.state.SortField,this.state.SortType);    
  }

  onChangeSortField(e) {
    this.setState({
      SortField: e.target.value
    });
    this.performSearch(this.state.ItemFilterByDescr,e.target.value,this.state.SortType);
  }

  onChangeItemFilterByDescr(e) {
    this.setState({
      ItemFilterByDescr: e.target.value
    });
    this.performSearch(e.target.value,this.state.SortField,this.state.SortType);
  }

  componentDidMount() {
    this.performSearch(this.state.ItemFilterByDescr, this.state.SortField,this.state.SortType);  
  }

  performSearch = (descr,sortfield,sorttype) => {
    ItemService.getItemByDescr(descr,sortfield,sorttype)
      .then(response => {
        console.log(response.data);
        this.setState({
          listOfItems: response.data
        });
        console.log(this.state.listOfItems);
      })
      .catch(e => {
        console.log(e);
      });
  };

  searchWithEnter = (event)=> {
    if (event.keyCode === 13) {
      this.performSearch();
    }
  }  

  render (){
    return (
      <>

      <div style={{display:"flex", flexDirection:"column",width:"100%"}}>
        <TopAndSideBar />
        <NewHeader headerTitle={"Items"}/>

        <Container>
          <Row className='mb-2 d-flex'>
            <Col lg={true}>
              <FormLabel className='mb-2'>Filter By Item Description:</FormLabel>       
              <FormControl type="text" name="filterbyitemdescription" id="filterbyitemdescription" onChange={this.onChangeItemFilterByDescr}></FormControl>
            </Col>
            <Col lg={true}>
              <FormLabel className='mb-2'>Sort By:</FormLabel>       
                <FormControl as='select' onChange={this.onChangeSortField}>
                  <option value="itempartnumber">Part Number</option>
                  <option value="itemdescription">Item Description</option>
                  <option value="standardsellingunitprice">Item Price</option>
                </FormControl>
            </Col>
            
            <Col sm={true}>
              <FormLabel className='mb-2'>Asc/Desc:</FormLabel>       
              <FormControl style={{maxWidth:"50px"}} as="button" onClick={this.onChangeSortType}><FaIcons.FaSortAmountDownAlt/></FormControl>
            </Col>          
          </Row>
          <Link to="/new-item" className="mr-2 btn btn-primary">New Item</Link>            
          <Button className="m-2 btn btn-primary">Export</Button>        
          <Row>
            <ItemsList mode={0} listOfItems = {this.state.listOfItems} />      
          </Row>
        </Container>
      </div>
      </>
    )
  }
}

export default Items;